/*
 * NDC: coșul lateral și pagina coșului – servicii opționale (Protecție colet, Livrare prioritară).
 * Bifele [data-ndc-cart-service] adaugă/scot produsul-serviciu (cantitate 1, o dată pe comandă).
 * Dacă în coș rămân doar servicii (fără produse), le scoate automat ([data-ndc-orphans]).
 * Pe pagina /cart reîmprospătează secțiunea paginii; în rest, coșul lateral.
 * Fișier propriu numeredecasa.ro (nu face parte din Horizon).
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const ROOT = window.Shopify?.routes?.root || '/';

function sectionId() {
  const page = document.querySelector('main cart-items-component[data-section-id]');
  return page?.dataset.sectionId || 'cart-drawer-section';
}

async function updateCart(updates, action, lines, input) {
  if (input) input.disabled = true;
  const SECTION = sectionId();
  let deferred = null;
  try {
    deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({ action, context: 'cart', lines, promise: deferred.promise })
    );
  } catch (e) {
    deferred = null;
  }
  try {
    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: SECTION }),
    });
    const cart = await res.json();
    if (deferred) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: cart.sections, itemCount: cart.item_count, source: 'ndc-cart' },
      });
    } else {
      location.reload();
    }
  } catch (error) {
    deferred?.reject?.(error);
    if (input) {
      input.checked = !input.checked;
      input.disabled = false;
    }
  }
}

function toggleService(input) {
  const on = input.checked;
  const variantId = String(input.dataset.variantId);
  const key = input.dataset.lineKey;
  if (on || !key) {
    updateCart({ [variantId]: on ? 1 : 0 }, 'add', [{ merchandiseId: variantId, quantity: on ? 1 : 0 }], input);
  } else {
    updateCart({ [variantId]: 0 }, 'update', [{ id: key, quantity: 0 }], input);
  }
}

function cleanupOrphans() {
  const el = document.querySelector('[data-ndc-orphans]');
  if (!el || el.dataset.ndcDone) return;
  el.dataset.ndcDone = '1';
  const ids = (el.dataset.ndcOrphans || '').split(',').filter(Boolean);
  const keys = (el.dataset.ndcOrphanKeys || '').split(',').filter(Boolean);
  if (!ids.length) return;
  const updates = {};
  ids.forEach((id) => { updates[id] = 0; });
  updateCart(updates, 'update', keys.map((key) => ({ id: key, quantity: 0 })));
}

document.addEventListener('change', (event) => {
  const input = event.target.closest?.('[data-ndc-cart-service]');
  if (input) toggleService(input);
});

document.addEventListener('shopify:cart:lines-update', (event) => {
  event.promise?.then?.(() => setTimeout(cleanupOrphans, 500), () => {});
});

cleanupOrphans();